'use strict';

ebStatusToggle.$inject = [];

function ebStatusToggle() {
    return {
        restrict: 'E',
        templateUrl: require('./ebStatusToggle.html'),
        scope: {
            for: '@',
            label: '@',
            model: '=',
            trueText: '@',
            trueClass: '@',
            falseText: '@',
            falseClass: '@',
            toggle: '&onToggle'
        }
    };
}

module.exports = ebStatusToggle;



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/admin/directives/ebStatusToggleDirective.js
// module id = 42
// module chunks = 0